import React from 'react';
import { Flex, Text, Tooltip } from '@chakra-ui/react';
import AleaFeature01Icon from '../../icons/AleaFeature01Icon.tsx';
import AleaFeature02Icon from '../../icons/AleaFeature02Icon.tsx';
import AleaFeature03Icon from '../../icons/AleaFeature03Icon.tsx';
import AleaFeature04Icon from '../../icons/AleaFeature04Icon.tsx';
import { ResidentFeature } from '../../constants/ResidentFeature.ts';
import { useTranslation } from 'react-i18next';
import AleaFeature05Icon from '../../icons/AleaFeature05Icon.tsx';

interface FeatureIconProps {
  title: string;
  label?: string;
  active: boolean;
  showText?: boolean;
  customColor?: string;
  alignment?: 'center' | 'flex-start';
}

const FeatureIcon: React.FC<FeatureIconProps> = ({ 
  title, 
  label, 
  active, 
  showText = false,
  customColor,
  alignment = 'center'
}) => {
  const { t } = useTranslation();
  
  const renderIcon = () => {
    switch (title) {
      case ResidentFeature.INCONTINENCE_MANAGEMENT_URINE:
        return <AleaFeature01Icon active={active} color={customColor} />;
      case ResidentFeature.INCONTINENCE_MANAGEMENT_STOOL:
        return <AleaFeature05Icon active={active} color={customColor} />;        
      case ResidentFeature.REPOSITIONING_MANAGEMENT:
        return <AleaFeature02Icon active={active} color={customColor} />;
      case ResidentFeature.SECURE_ZONE:
        return <AleaFeature03Icon active={active} color={customColor} />;
      case ResidentFeature.FALL_MANAGEMENT:
        return <AleaFeature04Icon active={active} color={customColor} />;
      default:
        return null;
    }
  };

  const displayLabel = label || t(title);

  const iconElement = (
    <Flex justifyContent={alignment} alignItems="center" minW={showText ? "35px" : "40px"}>
      {renderIcon()}
    </Flex>
  );

  if (showText) {
    return (
      <Flex alignItems="center">
        {iconElement}
        <Text fontSize="18px" ml="10px" color={customColor}>
          {displayLabel}
        </Text>
      </Flex>
    );
  }

  return (
    <Tooltip
      label={displayLabel}
      bg="#DCDCDC"
      color="alea.500"
      placement="bottom-start"
      borderRadius="20px"
      h="25px"
      px="10px"
    >
      {iconElement}
    </Tooltip>
  );
};

export default FeatureIcon;
